module.exports = __webpack_public_path__ + "public-ui/img/sbnk.8a6cc28e.svg";